import React from 'react'
import { DonutChart } from '../'
import { CountUsersSelector, CountAdminsSelector } from '../SelectorStates/SelectorStates'
import './mainCard.css'

const MainCard = () => {

  return (
    <>
        <div className='card-header-box-wrapper'>
            <a href="/users/view-users" className='card-main'>
                <div>
                    <div className='card-numbers'>{<CountUsersSelector />}</div>
                    <div className='card-names'>Users</div>
                </div>
                <DonutChart />
            </a>
            <a href="/posts/view-posts" className='card-main'>
                <div>
                    <div className='card-numbers'>{<CountAdminsSelector />}</div>
                    <div className='card-names'>Admins</div>
                </div>
                <DonutChart />
            </a>
            <a href="/orders/view-orders" className='card-main'>
                <div>
                    <div className='card-numbers'>{0}</div>
                    <div className='card-names'>Enrollments</div>
                </div>
                    <DonutChart />
            </a>
        </div>       
    </>
  )
}

export default MainCard